<template>
  <li
    class="page-subnav-item"
    :class="{active:active,disabled:disabled,isButton:hasListeners}"
    @click="onClick"
  >
    <slot></slot>
  </li>
</template>

<script>
export default {
  props: {
    active: Boolean,
    disabled: Boolean
  },
  computed: {
    hasListeners() {
      return this.$listeners.click;
    }
  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit("click");
      } else {
        this.$store.dispatch("playHowler", "denied");
      }
    }
  }
};
</script>

<style lang="scss">
.page-subnav-item {
  display: inline-block;
  margin-right: 5px;
  list-style: none;
  font-size: 13px;
  font-style: italic;
  // cursor: pointer;

  &:not(.active) {
    opacity: 0.5;
  }

  &.isButton {
    cursor: pointer;
  }

  &.disabled {
    cursor: not-allowed !important;
  }
}
</style>
